import React from 'react';
import ProductImage from './ProductImage';

export default function ProductIdentity({ product, title, sku, children, size = 48, zoom = true }) {
  const source = product?.orderItem?.product || product?.product || product || {};
  const name = title || product?.productTitle || product?.product_title || source.title || 'Товар';
  const article = sku ?? product?.productSku ?? product?.product_sku ?? product?.platform_sku ?? source.sellerSku ?? source.platformSku;
  return <div className="product-identity">
    <ProductImage product={product} alt={name} width={size} height={Math.round(size * 4 / 3)} zoom={zoom} />
    <div className="product-identity-copy"><strong>{name}</strong>{article && <small>Арт. {article}</small>}{children}</div>
  </div>;
}
